import { browserTracingIntegration, httpClientIntegration, init, replayIntegration, setTags } from '@sentry/browser';

export const isInitialised = () => !!window.chSentryInitialised;

const initSentry = (enabled: boolean, dsn: string, release: string, environment: string, tags: Record<string, string | number>) => {
    if (isInitialised()) {
        return;
    }

    init({
        dsn,
        release,
        environment,
        integrations: [
            browserTracingIntegration(),
            replayIntegration({
                maskAllText: true,
                blockAllMedia: true
            }),
            httpClientIntegration()
        ],
        tracesSampleRate: 0.005, // track 0.5% of transactions
        // only record sessions if an error has occured
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        enabled
    });

    setTags(tags);

    window.chSentryInitialised = true;
};

window.chSentryInit = initSentry;

export default initSentry;
